"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _ButtonBase = _interopRequireDefault(require("../ButtonBase"));
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _fabClasses = _interopRequireWildcard(require("./fabClasses"));
var _rootShouldForwardProp = _interopRequireDefault(require("../styles/rootShouldForwardProp"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var color = ownerState.color, variant = ownerState.variant, classes = ownerState.classes, size = ownerState.size;
    var slots = {
        root: [
            'root',
            variant,
            "size".concat((0, _capitalize.default)(size)),
            color === 'inherit' ? 'colorInherit' : color
        ]
    };
    var composedClasses = (0, _composeClasses.default)(slots, _fabClasses.getFabUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var FabRoot = (0, _zeroStyled.styled)(_ButtonBase.default, {
    name: 'MuiFab',
    slot: 'Root',
    shouldForwardProp: function(prop) {
        return (0, _rootShouldForwardProp.default)(prop) || prop === 'classes';
    },
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            styles["size".concat((0, _capitalize.default)(ownerState.size))],
            ownerState.color === 'inherit' && styles.colorInherit,
            styles[(0, _capitalize.default)(ownerState.size)],
            styles[ownerState.color]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var _theme_palette_getContrastText, _theme_palette;
    var _obj;
    return _object_spread_props(_object_spread({}, theme.typography.button), (_obj = {
        minHeight: 36,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color'
        ], {
            duration: theme.transitions.duration.short
        }),
        borderRadius: '50%',
        padding: 0,
        minWidth: 0,
        width: 56,
        height: 56,
        zIndex: (theme.vars || theme).zIndex.fab,
        boxShadow: (theme.vars || theme).shadows[6],
        '&:active': {
            boxShadow: (theme.vars || theme).shadows[12]
        },
        color: theme.vars ? theme.vars.palette.text.primary : (_theme_palette_getContrastText = (_theme_palette = theme.palette).getContrastText) === null || _theme_palette_getContrastText === void 0 ? void 0 : _theme_palette_getContrastText.call(_theme_palette, theme.palette.grey[300]),
        backgroundColor: (theme.vars || theme).palette.grey[300],
        '&:hover': {
            backgroundColor: (theme.vars || theme).palette.grey.A100,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette.grey[300]
            },
            textDecoration: 'none'
        }
    }, _define_property(_obj, "&.".concat(_fabClasses.default.focusVisible), {
        boxShadow: (theme.vars || theme).shadows[6]
    }), _define_property(_obj, "variants", [
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 40
            }
        },
        {
            props: {
                size: 'medium'
            },
            style: {
                width: 48,
                height: 48
            }
        },
        {
            props: {
                variant: 'extended'
            },
            style: {
                borderRadius: 48 / 2,
                padding: '0 16px',
                width: 'auto',
                minHeight: 'auto',
                minWidth: 48,
                height: 48
            }
        },
        {
            props: {
                variant: 'extended',
                size: 'small'
            },
            style: {
                width: 'auto',
                padding: '0 8px',
                borderRadius: 34 / 2,
                minWidth: 34,
                height: 34
            }
        },
        {
            props: {
                variant: 'extended',
                size: 'medium'
            },
            style: {
                width: 'auto',
                padding: '0 16px',
                borderRadius: 40 / 2,
                minWidth: 40,
                height: 40
            }
        },
        {
            props: {
                color: 'inherit'
            },
            style: {
                color: 'inherit'
            }
        }
    ]), _obj));
}), (0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        variants: _to_consumable_array(Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
            'dark',
            'contrastText'
        ])) // check all the used fields in the style below
        .map(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            return {
                props: {
                    color: color
                },
                style: {
                    color: (theme.vars || theme).palette[color].contrastText,
                    backgroundColor: (theme.vars || theme).palette[color].main,
                    '&:hover': {
                        backgroundColor: (theme.vars || theme).palette[color].dark,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }
            };
        }))
    };
}), (0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return _define_property({}, "&.".concat(_fabClasses.default.disabled), {
        color: (theme.vars || theme).palette.action.disabled,
        boxShadow: (theme.vars || theme).shadows[0],
        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
    });
}));
var Fab = /*#__PURE__*/ React.forwardRef(function Fab(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiFab'
    });
    var children = props.children, className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'default' : _props_color, _props_component = props.component, component = _props_component === void 0 ? 'button' : _props_component, _props_disabled = props.disabled, disabled = _props_disabled === void 0 ? false : _props_disabled, _props_disableFocusRipple = props.disableFocusRipple, disableFocusRipple = _props_disableFocusRipple === void 0 ? false : _props_disableFocusRipple, focusVisibleClassName = props.focusVisibleClassName, _props_size = props.size, size = _props_size === void 0 ? 'large' : _props_size, _props_variant = props.variant, variant = _props_variant === void 0 ? 'circular' : _props_variant, other = _object_without_properties(props, [
        "children",
        "className",
        "color",
        "component",
        "disabled",
        "disableFocusRipple",
        "focusVisibleClassName",
        "size",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        component: component,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(FabRoot, _object_spread_props(_object_spread({
        className: (0, _clsx.default)(classes.root, className),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
        ownerState: ownerState,
        ref: ref
    }, other), {
        classes: classes,
        children: children
    }));
});
process.env.NODE_ENV !== "production" ? Fab.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'default',
            'error',
            'info',
            'inherit',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */ component: _propTypes.default.elementType,
    /**
   * If `true`, the component is disabled.
   * @default false
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */ disableFocusRipple: _propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   */ disableRipple: _propTypes.default.bool,
    /**
   * @ignore
   */ focusVisibleClassName: _propTypes.default.string,
    /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */ href: _propTypes.default.string,
    /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'large'
   */ size: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'small',
            'medium',
            'large'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The variant to use.
   * @default 'circular'
   */ variant: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'circular',
            'extended'
        ]),
        _propTypes.default.string
    ])
} : void 0;
var _default = exports.default = Fab;
